import { normalizeTariff, parseList } from "../utils/tariffImportUtils";

function toJsonText(value) {
  return JSON.stringify(value || {}, null, 2);
}

function parseJsonText(value, fallback) {
  try {
    return JSON.parse(value || "");
  } catch (error) {
    return fallback;
  }
}

export default function TariffMappingEditor({ draft, onChange }) {
  if (!draft) {
    return (
      <section className="card tariff-import-card">
        <h2>4. Mapping</h2>
        <div className="empty-state">Bitte zuerst eine Datei hochladen oder einen leeren Tarif anlegen.</div>
      </section>
    );
  }

  const update = (patch) => onChange(normalizeTariff({ ...draft, ...patch }));

  return (
    <section className="card tariff-import-card">
      <div className="section-head">
        <div>
          <h2>4. Daten zuordnen</h2>
          <p className="section-text">
            Werte koennen nach dem Import manuell korrigiert oder vollstaendig eingefuegt werden.
          </p>
        </div>
      </div>

      <div className="form-grid columns-3 tariff-form-grid">
        <label className="field">
          <span>Tarifname</span>
          <input value={draft.tariffName} onChange={(event) => update({ tariffName: event.target.value })} />
        </label>

        <label className="field">
          <span>Spedition</span>
          <input value={draft.carrierName} onChange={(event) => update({ carrierName: event.target.value })} />
        </label>

        <label className="field">
          <span>Tarifart</span>
          <select value={draft.tariffType} onChange={(event) => update({ tariffType: event.target.value })}>
            <option value="Ausgang">Ausgang</option>
            <option value="Eingang">Eingang</option>
            <option value="Pickup">Pickup</option>
            <option value="Export">Export</option>
            <option value="Import">Import</option>
            <option value="Kundentarif">Kundentarif</option>
          </select>
        </label>
        <label className="field">
          <span>Land</span>
          <input placeholder="DE oder NL" value={draft.country || ""} onChange={(event) => update({ country: event.target.value })} />
        </label>

        <label className="field">
          <span>Relation</span>
          <input placeholder="Deutschland oder Niederlande" value={draft.relation || ""} onChange={(event) => update({ relation: event.target.value })} />
        </label>

        <label className="field">
          <span>zoneCount</span>
          <input type="number" min="1" step="1" value={draft.zoneCount || ""} onChange={(event) => update({ zoneCount: Number(event.target.value) || 0 })} />
        </label>

        <label className="field">
          <span>Gueltig von</span>
          <input type="date" value={draft.validFrom} onChange={(event) => update({ validFrom: event.target.value })} />
        </label>

        <label className="field">
          <span>Gueltig bis</span>
          <input type="date" value={draft.validTo} onChange={(event) => update({ validTo: event.target.value })} />
        </label>

        <label className="field">
          <span>Waehrung</span>
          <input value={draft.currency} onChange={(event) => update({ currency: event.target.value })} />
        </label>

        <label className="field field-wide">
          <span>Gewichtsstufen</span>
          <textarea
            rows="4"
            value={(draft.weightBreaks || []).join(";")}
            onChange={(event) => update({ weightBreaks: parseList(event.target.value) })}
          />
        </label>

        <label className="field field-wide">
          <span>Zonen</span>
          <textarea
            rows="3"
            value={(draft.zones || []).join(";")}
            onChange={(event) => update({ zones: parseList(event.target.value) })}
          />
        </label>

        <label className="field field-wide">
          <span>Tarifarten / Preistabellen JSON</span>
          <textarea
            rows="12"
            value={toJsonText(draft.tariffTables)}
            onChange={(event) => update({ tariffTables: parseJsonText(event.target.value, draft.tariffTables) })}
          />
        </label>
        <label className="field field-wide">
          <span>Preise JSON</span>
          <textarea
            rows="10"
            value={toJsonText(draft.prices)}
            onChange={(event) => update({ prices: parseJsonText(event.target.value, draft.prices) })}
          />
        </label>

        <label className="field field-wide">
          <span>PLZ-Zonen JSON</span>
          <textarea
            rows="8"
            value={toJsonText(draft.postalCodeZones)}
            onChange={(event) =>
              update({
                postalCodeZones: parseJsonText(event.target.value, draft.postalCodeZones),
              })
            }
          />
        </label>

        <label className="field field-wide">
          <span>Sperrigkeits-/Mindestgewichte JSON</span>
          <textarea
            rows="7"
            value={toJsonText(draft.packageRules)}
            onChange={(event) => update({ packageRules: parseJsonText(event.target.value, draft.packageRules) })}
          />
        </label>
        <label className="field field-wide">
          <span>Versicherungstabelle JSON</span>
          <textarea
            rows="7"
            value={toJsonText(draft.insuranceTable)}
            onChange={(event) => update({ insuranceTable: parseJsonText(event.target.value, draft.insuranceTable) })}
          />
        </label>


        <label className="field field-wide">
          <span>Zuschlaege JSON</span>
          <textarea
            rows="7"
            value={toJsonText(draft.surcharges)}
            onChange={(event) => update({ surcharges: parseJsonText(event.target.value, draft.surcharges) })}
          />
        </label>
      </div>
    </section>
  );
}







